module.exports = __webpack_public_path__ + "static/media/sams-1.65d7b165.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/logos/sams-1.png
// module id = 694
// module chunks = 0